module.exports = __webpack_public_path__ + "static/media/newsletter-november-2024-1.4cb498e1.jpg";